export default {"src":"/_next/static/media/facebookInstagram.62fe2c5a.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};